
<div class="form__group--border pt-32 pb-16">
  <fieldset>
    <legend class="form__label pb-8">{{ legend }}</legend>
    <ul>
      <li v-for="option in options" :key="option.value">
        <PoppinsCheckbox
          v-model="qualifications"
          :labelName="option.optionText"
          :aria-label="generateScreenReaderLabel(option.optionText)"
          :value="option.value"
        />
      </li>
    </ul>
  </fieldset>
</div>
